import React from "react";

const PageNotFound = () => {
  return (
    <div
      className="container"
      style={{
        marginTop: "8rem",
        color: "dimgray",
      }}
    >
      <h1 className="text-center"> Page Not Found </h1>{" "}
    </div>
  );
};

export default PageNotFound;
